import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import SearchAdvice from '~/components/_next/template/search/SearchAdvice.vue';
import SearchRecipe from '~/components/_next/template/search/SearchRecipe.vue';
import SearchProduct from '~/components/_next/template/search/SearchProduct.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import ProductCardSkeleton from '~/assets/images/skeletons/product-card.svg?inline';
import { AisInstantSearch } from 'vue-instantsearch';
import sanitizeHtml from 'sanitize-html';
import { useAlgoliaSearch } from '~/composables/_next/useAlgoliaSearch';
import { instantScrollTo } from '~/helpers/ui/windowBehaviors';
import { useWait } from '~/composables/_next/useWait';
export default /*#__PURE__*/_defineComponent({
  __name: 'AlgoliaSearch',
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var SearchUpsell = function SearchUpsell() {
      return import('~/components/_next/organisms/search/searchUpsell.vue');
    };
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var _useAlgoliaSearch = useAlgoliaSearch(),
      searchClient = _useAlgoliaSearch.searchClient;
    var route = useRoute();
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      isWaiting = _useWait.isWaiting,
      endWaiter = _useWait.endWaiter;
    startWaiter('search');
    var query = computed(function () {
      return route.params.term;
    });
    var numberHits = ref({
      product: 0,
      recipe: 0,
      advice: 0
    });
    var totalHits = computed(function () {
      return numberHits.value.product + numberHits.value.recipe + numberHits.value.advice;
    });
    var isEmptyResult = computed(function () {
      return totalHits.value === 0;
    });
    var headerTitle = computed(function () {
      return sanitizeHtml(i18n.tc('search-result.desktop-title', totalHits.value, {
        name: query.value
      }));
    });
    var validTabs = ['products', 'recipes', 'advices'];
    var activeTab = ref('products');
    var currentTabId = computed(function () {
      var _tabs$value$find$id, _tabs$value$find, _tabs$value;
      return (_tabs$value$find$id = (_tabs$value$find = tabs.value.find(function (tab) {
        return tab.id === activeTab.value;
      })) === null || _tabs$value$find === void 0 ? void 0 : _tabs$value$find.id) !== null && _tabs$value$find$id !== void 0 ? _tabs$value$find$id : (_tabs$value = tabs.value) === null || _tabs$value === void 0 ? void 0 : _tabs$value[0].id;
    });
    var currentTabIndex = computed(function () {
      return tabs.value.findIndex(function (tab) {
        return tab.id === activeTab.value;
      });
    });
    var tabs = computed(function () {
      return [{
        id: 'products',
        label: i18n.tc('search.products'),
        count: numberHits.value.product
      }, {
        id: 'recipes',
        label: i18n.tc('search.recipes'),
        count: numberHits.value.recipe
      }, {
        id: 'advices',
        label: i18n.tc('search.advices'),
        count: numberHits.value.advice
      }];
    });

    /**
     * Updates the number of product hits.
     * @param {number} hits - The number of product hits.
     */
    function handleProductHits(hits) {
      endWaiter('search');
      numberHits.value.product = hits;
    }

    /**
     * Updates the number of recipe hits.
     * @param {number} hits - The number of recipe hits.
     */
    function handleRecipeHits(hits) {
      endWaiter('search');
      numberHits.value.recipe = hits;
    }

    /**
     * Updates the number of advice hits.
     * @param {number} hits - The number of advice hits.
     */
    function handleAdviceHits(hits) {
      endWaiter('search');
      numberHits.value.advice = hits;
    }

    /**
     * Selects a specific tab by its ID and emits an update event.
     * @param {string} id - The ID of the selected tab.
     */
    function selectTab(id) {
      route.query.type = activeTab.value;
      route.query.page = '1';
      activeTab.value = id;
      emit('update:modelValue', id);
      if (process.client) {
        // Necessary to update the URL query parameter
        // as route.query does not update the URL directly
        var oldQuery = _objectSpread({}, route.query);
        var queryUpdate = _objectSpread(_objectSpread({}, oldQuery), {}, {
          page: '1',
          type: id
        });
        var fullRoute = window.location.origin + route.path;
        var urlParams = new URLSearchParams(queryUpdate).toString();
        history.replaceState({}, null, "".concat(fullRoute, "?").concat(urlParams));
      }
    }
    watch(function () {
      return route.query.page;
    }, function (newPage) {
      if (newPage && process.client) {
        instantScrollTo({
          top: 0
        });
      }
    });
    watch(function () {
      return route.query.type;
    }, function (newType) {
      if (typeof newType === 'string' && validTabs.includes(newType)) {
        activeTab.value = newType;
      }
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      SearchUpsell: SearchUpsell,
      i18n: i18n,
      searchClient: searchClient,
      route: route,
      startWaiter: startWaiter,
      isWaiting: isWaiting,
      endWaiter: endWaiter,
      query: query,
      numberHits: numberHits,
      totalHits: totalHits,
      isEmptyResult: isEmptyResult,
      headerTitle: headerTitle,
      validTabs: validTabs,
      activeTab: activeTab,
      currentTabId: currentTabId,
      currentTabIndex: currentTabIndex,
      emit: emit,
      tabs: tabs,
      handleProductHits: handleProductHits,
      handleRecipeHits: handleRecipeHits,
      handleAdviceHits: handleAdviceHits,
      selectTab: selectTab,
      SearchAdvice: SearchAdvice,
      SearchRecipe: SearchRecipe,
      SearchProduct: SearchProduct,
      AzBackToTopButton: AzBackToTopButton,
      ProductCardSkeleton: ProductCardSkeleton,
      AisInstantSearch: AisInstantSearch
    };
  }
});